import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 'app-station-card-hover',
    templateUrl: './station-card-hover.component.html',
    styleUrls: ['./station-card-hover.component.scss'],
    exportAs: 'appStationCardHover'
})
export class StationCardHoverComponent implements OnInit {

    @Input()
    public icon: string;
    @Input()
    public label: string;
    @Output()
    public eventClick: EventEmitter<any> = new EventEmitter<any>();

    constructor() { }

    ngOnInit() {
    }

    onEventClick() {
        this.eventClick.emit();
    }
}
